var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import IconButton from '@mui/material/IconButton';
import { styled, alpha } from '@mui/material';
export var Component = styled(IconButton)(function (_a) {
    var variant = _a.variant, theme = _a.theme, color = _a.color;
    return (__assign(__assign(__assign(__assign(__assign({}, (variant === 'contained' &&
        color === 'primary' && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    })), (variant === 'contained' &&
        color === 'secondary' && {
        backgroundColor: '#F5F5F5',
        '&:hover': {
            backgroundColor: '#EBEBEB',
        },
    })), (!variant &&
        color === 'primary' && {
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
    })), (!variant &&
        color === 'secondary' && {
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    })), { '&.MuiIconButton-root': {
            width: 'fit-content',
            '.MuiSvgIcon-fontSizeSmall': {
                fontSize: '20px',
            },
            '.MuiSvgIcon-fontSizeMedium': {
                fontSize: '24px',
            },
            '.MuiSvgIcon-fontSizeLarge': {
                fontSize: '35px',
            },
        }, '&.MuiIconButton-sizeMedium': {
            padding: '12px',
        }, '&.MuiIconButton-sizeSmall': {
            padding: '4px',
        } }));
});
Component.displayName = 'IconButton';
